import styled from 'styled-components'

export const Main = styled.main`
    div.appHeader {
        a[aria-label='chat with vietnamworks'] {
            bottom: 180px;
            @media (min-width: 769px) {
                bottom: 270px;
            }
        }
    }
`
